module.exports = "/_next/static/images/3dbf0c16a78f4317762921839b07e370-phone-recharge-icon.svg";